import React, { useEffect, useState } from 'react'
import CategorySmallBanner from 'src/components/BookAppliance/BookApplianceModal/BookApplianceShopByCategory/CategorySmallBanner'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useAppDispatch } from 'src/store/store'
import { useRouter } from 'next/router'
import WomenCategorySelectSection from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/WomenCategorySelectSection'
import ShopByCategoryDetails from 'src/components/Category/ShopByCategoryDetails'
import CategorySlider from 'src/components/Category/CategoryComman/CategorySlider'
import SubCategoryProductSection from 'src/components/Category/CategoryComman/SubCategoryProductSection'
import { useSelector } from 'react-redux'
import { fetchCategoryBySlug } from 'src/store/slices/fetchCategory'
import client1 from 'src/utils/apolloClient'
import GET_SINGLE_CATEGORY from 'src/graphql/queries/getSingleCategory'
import { fetchProductByCategory, setProductByCategoryState } from 'src/store/slices/fetchAllProduct'
import ShopCubeSlider from 'src/components/Shop/ShopCubeSlider'
import { fetchModalData } from 'src/store/slices/manageModalSlice'
import ShopHotDealsModal from 'src/components/Shop/ShopHotDealsModal'
import WomenCategorySlider from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/WomenCategorySelectSection/WomenCategorySlider'
import CategoryDetail from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/CategoryDetail'
import BrowseCatagory from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/BrowseCatagory'
import WomenproductPhotossection from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/WomenproductPhotossection'
import Weekofoffersection from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/Weekoffersection'
import JeweleryarrivalAcceccories from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/Jeweleryarrival'
import { isZoreOrEmpty } from 'src/utils/isEmpty'

const Bagimage = '/assets/accessories/bagimage.png'
const Hatimage = '/assets/accessories/hatimage.png'
const Galssesimage = '/assets/accessories/galssesimage.png'
const Scarves = '/assets/accessories/scarves.png'

export default function WomenCategoryMain({ caterogoyName }) {
  const router = useRouter()
  const [scrolling, setScrolling] = useState(0)
  const sub_category_slug = router?.pathname.split('/')[2]
  const [page, setPage] = useState(1)
  const [dataLimite, setDataLimite] = useState(40)
  const [maxPrice, setMaxPrice] = useState(1000) // Set initial max value
  const [minPrice, setMinPrice] = useState(1)
  const [productData, setProductData] = useState({
    total: 0,
    data: [],
  })
  const dispatch = useAppDispatch()
  const categoryData = useSelector((state: any) => state?.fetchCategory?.womenAccessoriesCategoryData)
  const getAllState = useSelector((state: any) => state?.manageModalData?.data)
  let filterData = categoryData?.find((cat) => cat?.slug === router?.query?.id)
  const productByCategory = useSelector((state: any) => state?.productByCategory)
  const childCategoryValue = router?.query?.id;

  useEffect(() => {
    setPage(1)
    dispatch(
      fetchCategoryBySlug({
        type: 'CHILD_SUB_CATEGORY',
        categoryName: 'Fashion & Accessories',
        subcategoryName: sub_category_slug,
        childsubSlug: '',
        nestedSlug: '',
      }),
    )
  }, [])

  const handleClose = () => {
    router.push('/fashion/women/', undefined, { scroll: false })
    dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
  }

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const callAsPerRoute = () => {
    switch (caterogoyName) {
      case 'accessories':
        return <></>
      case 'public_collection':
        return <></>
      default:
        return ''
    }
  }

  const handleOpenModal = ({ modalName, title, description, color, childSubCategoryId }) => {
    dispatch(
      fetchModalData({
        allModalData: [
          ...getAllState?.allModalData,
          {
            modal: modalName,
            isOpen: true,
            id: {
              title,
              description,
              color,
              childSubCategoryId,
            },
            modalFor: 'bigModal',
          },
        ],
        lastModalData: getAllState?.lastModalData,
      }),
    )
  }

  const womenImageArray = [
    { image: Bagimage, title: 'Bags' },
    { image: Hatimage, title: 'Hats' },
    { image: Galssesimage, title: 'Glasses' },
    { image: Scarves, title: 'Scarves' },
    { image: Bagimage, title: 'Bags' },
    { image: Hatimage, title: 'Hats' },
    { image: Galssesimage, title: 'Glasses' },
    { image: Scarves, title: 'Scarves' },
  ]

  useEffect(() => {
    dispatch(
      setProductByCategoryState({
        getAllProducts: {
          data: [],
        },
      }),
    )
    fetchProduct()
  }, [childCategoryValue, page, minPrice, maxPrice])

  const fetchProduct = (maxPriceValue = null, minPriceValue = null) => {
    if (isZoreOrEmpty(maxPriceValue) && isZoreOrEmpty(minPriceValue) || (maxPrice && minPrice)) {
      dispatch(
        fetchProductByCategory({
          category: 'fashion-and-accessories',
          subCategory: router?.asPath?.includes('women-accessories') ? "women-accessories" : "men-accessories",
          childSubCategory: childCategoryValue ? childCategoryValue : '',
          isShopifyProduct: false,
          page: page,
          limit: dataLimite,
          maxPrice: maxPriceValue || maxPrice,
          minPrice: minPriceValue || minPrice,
        }),
      )
      // .then((data) => {
      //   console.log('data+++++++++++++++++++++++++++++', data)
      //   setProductData(data?.payload?.getAllProducts)
      // })
      // .catch((error) => {
      //   console.log('error', error)
      // })
    }

  }

  const fetchUpdatedProduct = (product_id, type) => {
    let update_product = []
    if (type === 'price') {
      setMaxPrice(product_id?.maxValue)
      setMinPrice(product_id?.minValue)
      fetchProduct(product_id?.maxValue, product_id?.minValue)
    } else if (type === 'dislike') {
      update_product = productData?.data?.map((prd) => {
        if (prd?.id === product_id) {
          return {
            ...prd,
            likes: null,
          }
        } else {
          return prd
        }
      })
    } else if (type === 'like') {
      update_product = productData?.data?.map((prd) => {
        if (prd?.id === product_id) {
          return {
            ...prd,
            likes: {
              id: 3.3333,
            },
          }
        } else {
          return prd
        }
      })
    }
    dispatch(
      setProductByCategoryState({
        getAllProducts: {
          data: update_product,
        },
      }),
    )
  }

  return (
    <React.Fragment>
      <CategorySmallBanner
        categoryData={categoryData}
        scrollY={scrolling}
        handleClose={handleClose}
        pathname={`/fashion/${sub_category_slug}`}
      />
      {caterogoyName === 'accessories' ? (
        <React.Fragment>
          <div className="Women-accecccies-page-layout-alignment">
            <button className="Backbuttonmain" onClick={() => router.back()}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M16 19L9 12L16 5"
                  stroke="#7A7E88"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <div className="mobileSubCategory-back-alignment">
              <div className="back_details-alignment" onClick={() => router.push('/fashion/women')}>
                <div>
                  <img src="/assets/icon/left-icon.svg" alt="back-page" />
                </div>
                <p>Woma...</p>
              </div>
              <div className="mobile-heading-alignment">
                <h4>Shop by Cate...</h4>
              </div>
            </div>
            <div className="Women-accecccies-page-layout">
              <div className="womencatagoryslideralignment">
                {/* <WomenCategorySelectSection colletionData={categoryData} /> */}
                <WomenCategorySlider colletionData={categoryData} subCategoryRoute={'women-accessories'} />
              </div>
              <CategoryDetail filterData={filterData} caterogoyName={caterogoyName} fontColor={'#000000'} />
              {childCategoryValue && <BrowseCatagory
                sub_category_slug={sub_category_slug}
                childsubSlug={childCategoryValue}
                backgroundColor={'#EEF1FD'}
                imageBackgroundColor={'#D2D8F4'}
                imageArray={womenImageArray}
                subcategoryName={'women-accessories'}
                fontColor={'#00000'}
              />}
              {/* <CategorySmallBanner
                categoryData={categoryData}
                scrollY={scrolling}
                handleClose={handleClose}
                pathname={sub_category_slug}
              /> */}
              <ShopCubeSlider
                handleOpenModal={handleOpenModal}
                modalName={'shopCubProductSeeAll'}
                title={'From Brands You Love'}
                description={'Highly rated products from brands you might like'}
                height={'353px'}
                color={'#F3E0D5'}
                isSeeAll={true}
                childSubCategoryId={[[124], [98], [102], [110]]}
                titleColor={'#1E2432'}
                descriptionColor={'#808191'}
              />

              <JeweleryarrivalAcceccories category={'jewelry'} subCategory={'women'} childSubCategory={''} />
              {/* <ShopHotDealsModal setIsMobileNewArrival={() => {}} /> */}

              {/* <Weekofoffersection /> */}

              <ShopByCategoryDetails
                category_id={[35]}
                subCategory_id={[18]}
                storetitle={'Accessories Stores'}
                storeModalName={'jewelryStoreModal'}
                clubTitle={'Accessories Clubs'}
                dataLimite={dataLimite}
                setPage={setPage}
                page={page}
              />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {childCategoryValue && <>
            <WomenCategorySelectSection
              colletionData={categoryData}
              fetchUpdatedProduct={fetchUpdatedProduct}
              setPage={setPage}
              page={page}
              dataLimite={dataLimite}
              subCategoryRoute={'women-accessories'}
              category={'Fashion & Accessories'}
              subCategory={"Women's Accessories"}
              childSubCategory={childCategoryValue}
            />
            <div className='mt-5'>
              <SubCategoryProductSection
                category={'Fashion & Accessories'}
                subCategory={"Women's Accessories"}
                childSubCategory={childCategoryValue}
                page={page}
                setPage={setPage}
                fetchUpdatedProduct={fetchUpdatedProduct}
                productData={productByCategory}
              />
            </div>
          </>}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export async function getServerSideProps({ params }) {
  const { id } = params

  try {
    const { data } = await client1.query({
      query: GET_SINGLE_CATEGORY,
      variables: {
        type: 'CHILD_SUB_CATEGORY',
        categoryName: 'Fashion & Accessories',
        subcategoryName: 'women-accessories',
        childsubSlug: '',
        nestedSlug: '',
      },
      fetchPolicy: 'network-only',
    })

    let find_category = data?.getSingleCategory?.data.find((cat) => cat?.slug === id)

    if (find_category) {
      return {
        props: {
          caterogoyName: find_category?.slug,
        },
      }
    } else {
      return {
        notFound: true,
      }
    }
  } catch (error) {
    return {
      notFound: true,
    }
  }
}
